module.exports = __webpack_public_path__ + "img/lg_ring_y_i_null_1@2x.f34d3ca3.png";